import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import { NAV_LINKS, scrollToId } from "@/data/content";
import { useSiteSettings } from "@/lib/settings";

const Footer = () => {
  const contacts = useSiteSettings();
  return (
  <footer className="bg-ink text-ivory" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sage text-ivory">
            <Leaf size={17} strokeWidth={1.8} />
          </span>
          <span className="font-serif text-xl font-semibold">Orto della Longevità</span>
        </div>
        <p className="mt-4 font-serif text-lg italic text-ivory/70">Un luogo dove sentirsi a casa.</p>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-ivory/55">
          Benessere, serenità e qualità della vita in tre residenze immerse nel verde dell'Umbria.
        </p>
      </div>
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-terracotta">Esplora</p>
        <ul className="mt-5 space-y-2.5">
          {NAV_LINKS.map((l) => (
            <li key={l.id}>
              <button data-testid={`footer-link-${l.id}`} onClick={() => scrollToId(l.id)} className="text-sm text-ivory/70 transition-colors hover:text-terracotta">
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-terracotta">Contatti</p>
        <ul className="mt-5 space-y-2.5 text-sm text-ivory/70">
          <li><a data-testid="footer-phone" href={contacts.phoneHref} className="transition-colors hover:text-terracotta">{contacts.phoneDisplay}</a></li>
          <li><a data-testid="footer-mobile" href={contacts.mobileHref} className="transition-colors hover:text-terracotta">{contacts.mobileDisplay}</a></li>
          <li><a data-testid="footer-email" href={`mailto:${contacts.email}`} className="transition-colors hover:text-terracotta">{contacts.email}</a></li>
          <li>{contacts.address}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-ivory/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 text-xs text-ivory/45 sm:flex-row sm:px-8">
        <p>© 2026 Orto della Longevità · P.IVA 00000000000 · Casa di riposo a Castel Giorgio, Umbria</p>
        <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-terracotta">
          Area Riservata
        </Link>
      </div>
    </div>
  </footer>
);
};

export default Footer;
